module.exports = __webpack_public_path__ + "assets/img/pv.d8ab823b.webp";